import React from 'react';
import {
  Box, Typography, Paper, IconButton, Dialog, DialogTitle,
  DialogContent, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { NotificationStats } from '../types';

interface NotificationStatsDialogProps {
  open: boolean;
  onClose: () => void;
  statsData: NotificationStats | null;
  loading: boolean;
}

const NotificationStatsDialog: React.FC<NotificationStatsDialogProps> = ({
  open,
  onClose,
  statsData,
  loading
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: '8px', p: 0.5 } }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', py: 1, px: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
          Прочтения: {statsData?.totalReads || 0}
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: '#64748b' }}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1.5, px: 2 }}>
        {loading ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <CircularProgress size={24} sx={{ color: '#2563eb' }} />
          </Box>
        ) : statsData ? (
          <Box>
            <Paper variant="outlined" sx={{ p: 1, mb: 1.5, bgcolor: '#f8fafc', borderColor: '#e2e8f0', borderRadius: '6px' }}>
              <Typography variant="body2" sx={{ color: '#1e293b', fontSize: '0.82rem', lineHeight: 1.35 }}>
                {statsData.notification.message}
              </Typography>
            </Paper>

            <TableContainer sx={{ maxHeight: 280, border: '1px solid #e2e8f0', borderRadius: '6px' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: '#f1f5f9', py: 0.8, fontSize: '0.75rem', fontWeight: 600 }}>Аптека</TableCell>
                    <TableCell sx={{ bgcolor: '#f1f5f9', py: 0.8, fontSize: '0.75rem', fontWeight: 600 }}>Логин</TableCell>
                    <TableCell sx={{ bgcolor: '#f1f5f9', py: 0.8, fontSize: '0.75rem', fontWeight: 600 }}>Время</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {statsData.reads.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={3} sx={{ textAlign: 'center', py: 3, color: '#64748b', fontSize: '0.8rem' }}>
                        Никто еще не прочитал
                      </TableCell>
                    </TableRow>
                  ) : (
                    statsData.reads.map((r, idx) => (
                      <TableRow key={idx} hover sx={{ borderBottom: '1px solid #f1f5f9' }}>
                        <TableCell sx={{ py: 0.6, fontSize: '0.78rem', color: '#0369a1', fontWeight: 600 }}>
                          {r.pharmacyNum ? `№${r.pharmacyNum}` : '-'}
                        </TableCell>
                        <TableCell sx={{ py: 0.6, fontSize: '0.78rem', color: '#1e293b' }}>{r.username}</TableCell>
                        <TableCell sx={{ py: 0.6, fontSize: '0.75rem', color: '#15803d' }}>
                          {new Date(r.readAt).toLocaleString('ru-RU')}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default NotificationStatsDialog;
